import React, { useEffect, useState } from 'react';
import { listSeasons } from '../utils/seasonApi';

const SeasonSwitcher = ({ teamId, activeSeason, onChange, seasons: seasonsProp }) => {
  const [seasons, setSeasons] = useState(seasonsProp || []);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (seasonsProp && seasonsProp.length) {
      setSeasons(seasonsProp);
    }
  }, [seasonsProp]);

  useEffect(() => {
    if (!teamId || (seasonsProp && seasonsProp.length)) return;
    setLoading(true);
    listSeasons(teamId)
      .then((rows) => setSeasons(rows))
      .catch((err) => {
        console.error('Failed to load seasons', err);
        setSeasons([]);
      })
      .finally(() => setLoading(false));
  }, [teamId, seasonsProp]);

  // Build options from season rows; prefer season year as selector value.
  const optionList = (() => {
    const seen = new Set();
    const list = [];
    const add = (value, displayName) => {
      const key = value != null ? String(value) : '';
      if (!key || seen.has(key)) return;
      seen.add(key);
      list.push({ id: key, displayName: displayName || key });
    };

    seasons.forEach((s) => {
      const seasonId = s?.id != null ? String(s.id) : '';
      const seasonYear = s?.year != null ? String(s.year) : seasonId;
      const seasonLabel = s?.displayName || (seasonYear || seasonId);
      const label = seasonYear && seasonId && seasonYear !== seasonId
        ? `${seasonYear} - ${seasonLabel}`
        : seasonLabel;
      add(seasonYear || seasonId, label);
    });
    add(activeSeason, activeSeason);

    return list;
  })();

  return (
    <div className="season-switcher" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={{ color: '#a3adc2', fontSize: '13px' }}>Season</label>
      <select
        disabled={loading || (!optionList.length && !activeSeason)}
        value={activeSeason || ''}
        onChange={(e) => onChange(e.target.value)}
        style={{
          background: '#111827',
          color: 'white',
          border: '1px solid #374151',
          borderRadius: '6px',
          padding: '6px 10px',
          minWidth: '120px',
        }}
      >
        {!activeSeason && <option value="">Select</option>}
        {optionList.map((s) => (
          <option key={s.id} value={s.id}>
            {s.displayName || s.id}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SeasonSwitcher;
